import React from 'react'
import { mapPage, mapMetaData } from '../../utils/mapper'
import ServiceFocusContent from '../../components/servicefocus'
import { withStyles } from '@material-ui/core/styles'
import styles from '../../styles/site'

const serviceFocus = props => {
  const { policies } = props
  const metadata = mapMetaData(props.data.serviceFocus)
  const data = mapPage(props.data.serviceFocus)
  return (
    <div>
      <ServiceFocusContent
        data={data}
        metadata={metadata}
        policies={policies}
      />
    </div>
  )
}

export default withStyles(styles)(serviceFocus)

export const query = graphql`
  query serviceFocusTypeQuery($id: String!) {
    serviceFocus: prismicCtServiceFocus(id: { eq: $id }) {
      ...serviceFocus
    }
    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/services/service-focus.js